import loadable from '@loadable/component';

import { ordersLC } from 'src-sites/domik/section-projects/orders';

const ContentBanner = loadable(() =>
  import(/* webpackChunkName: "content-banner" */ 'containers/content-block/blocks/content-banner'));

const stocksViewSlider = loadable(() =>
  import(/* webpackChunkName: "block-newBuildList-stockViewSlider" */ './stocks/stocksViewSlider'));

const stocksViewSliderWithConversions = loadable(() =>
  import(/* webpackChunkName: "block-newBuildList-stockViewSlider-WithConversions" */ './stocks/stocksViewSliderWithConversions'));

const LastTopics = loadable(() =>
  import(/* webpackChunkName: "block-lastTopicList-lastTopics" */ './last-topics/last-topics'));

const Developers = loadable(() =>
  import(/* webpackChunkName: "block-developers" */ './developers/developers'));

const UserAdvertList = loadable(() =>
  import(/* webpackChunkName: "block-userAdvert-topicView" */ 'containers/content-block/blocks/userAdvert/advertList'));

// const UserAdvertPostView = loadable(() =>
//   import(/* webpackChunkName: "block-userAdvert-topicView" */ './userAdvert/topicView'));

const nbOrders = [{ id: ordersLC().length, value: 'Рандом', param: [['rand', 'asc']] }];

/**
 * Overrides and extends default block config from containers/content-block/config.js
 */
const cfg = {
  landingLink: {
  },
  newbuildsList: {
  },
  nbStocksList: {
    provider: 'domik/location/newbuilds-stocks-list',
    controller: 'admin/content-blocks/bild/newbuilds-stocks-list',
    orders: nbOrders,
    views: {
      stocksView: {
        name: 'Вид "Акции"',
        component: stocksViewSlider,
        props: { view: 'stocks' }
      },
      stocksViewWC: {
        name: 'Вид "Акции" с конверсией',
        component: stocksViewSliderWithConversions,
        props: { view: 'stocks' }
      },
    }
  },
  lastTopics: {
    provider: 'forum/topic-list',
    controller: 'admin/content-blocks/forum/last-topics',
    orders: [
      { id: 0, value: 'свежие вверху', param: [['topic_last_post_time', 'desc']] }
    ],
    views: {
      default: {
        name: 'По умолчанию',
        component: LastTopics,
        props: { view: 'bg' }
        // props: { type: 'rand', view: 'dark', Block: BView1 }
      }
    }
  },
  bannerLcBlock: {
  },
  bannerList: {
    provider: 'common/region-banners/banner-list',
    controller: 'admin/content-blocks/banners/banner-list',
    orders: [],
    views: {
      default: {
        name: 'По умолчанию',
        component: ContentBanner,
        props: { view: 'banner' }
      }
    }
  },
  developers: {
    provider: 'domik/users/developers-list',
    controller: 'admin/content-blocks/domik/developers',
    orders: [
      { id: 0, value: 'По готовым домам', param: ['ready_house', 'desc'] },
      { id: 1, value: 'По строящимся домам', param: ['in_progress_house', 'desc'] }
    ],
    views: {
      default: {
        name: 'По умолчанию',
        component: Developers,
        props: { view: 'developers' }
      }
    }
  },
  userAdvertList: {
    provider: 'user-advert/content-advert-list',
    controller: 'admin/content-blocks/user-advert/user-advert-list',
    orders: [],
    views: {
      topicView: {
        name: 'Вид "В темах"',
        component: UserAdvertList,
        props: { view: 'topic' }
      },
      postsView: {
        name: 'Вид "В постах"',
        component: UserAdvertList,
        props: { view: 'post' }
      }
    }
  },
  staticBlock: {
  }
};

export default cfg;
